import styled, { css } from 'styled-components';

import { AspectRatioImage } from '@/components/AspectRatioImage/AspectRatioImage';
import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Select } from '@/components/Select';
import { theme } from '@/theme';

import { ReactComponent as ChevronSvg } from '@/assets/icons/chevron.svg';
export const TopBannerWrapper = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    position: relative;
    height: 320px;
    ${theme.media.md.up} {
      height: 340px;
    }
  `};
`;

export const BreadCrumbSection = styled(Box)`
  ${({ theme }) => css`
    padding-top: 0;
    position: relative;
    z-index: 3;
    ${theme.media.md.up} {
      padding-top: 5px;
    }
  `};
`;

export const BreadCrumbWrapper = styled(Container)`
  z-index: 3;
`;

export const BreadCrumbContent = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding-top: ${theme.spacing(1.6)};
    padding-bottom: ${theme.spacing(1.6)};
    ${theme.media.md.up} {
      padding-top: ${theme.spacing(1.6)};
    }
  `};
`;

export const TextWrapper = styled(Box)`
  position: relative;
  ${({ theme }) => css`
    margin: 0 auto;
    max-width: 1400px;
    box-sizing: border-box;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    position: relative;
    padding-right: 15px;
    padding-left: 15px;
    height: 100%;
    width: 100%;
    z-index: 3;
    ${theme.media.md.up} {
    }
  `};
`;
export const TextContainer = styled(Box)`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${theme.spacing(5)};
    min-width: 100%;
    ${theme.media.md.up} {
    }
  `};
`;
export const StyledHeading = styled.h1`
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    margin: 0.67em 0;
    line-height: 1;
    letter-spacing: 0;
    margin-bottom: 0;
    margin-top: 0;
    font-size: 40px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    padding-bottom: 10px;
    color: ${theme.colors.white};
    ${theme.media.md.up} {
      font-size: 50px;
      text-align: center;
    }
  `};
`;
export const StyledSelect = styled(Select)`
  ${({ theme }) => css`
    & > div {
      width: 320px;
    }
    ${theme.media.md.up} {
      & > div {
        width: 240px;
      }
    }
  `};
`;
export const BannerImageWrapper = styled(Box)`
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
`;
export const Mask = styled(Box)`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.4);
  left: ${theme.spacing(0)};
  top: ${theme.spacing(0)};
`;

export const StyledAspectRatioImage = styled(AspectRatioImage)`
  object-fit: cover;
  height: 100%;
`;
export const Chevron = styled(ChevronSvg)`
  width: 24px;
  fill: ${({ theme }) => theme.colors.primary};
  margin-left: -4px;
`;
export const ChangeStoreCtaWrapper = styled(Box)`
  width: auto;
`;
export const LocationSvgWrapper = styled(Box)`
  display: inline-block;
  padding-right: ${theme.spacing(0.5)};
  & > svg {
    transform: translateY(2px);
  }
`;
